export class Common {

    constructor() {}

    getString( value, defaultValue ) {
        try {
            if( ( typeof value == "string" ) && ( value.length > 0 ) ) {
                return value;
            }
            else if( typeof value == "number" ) {
                return value.toString();
            }
        }
        catch( e ) {
            //
        }
        return defaultValue;
    }

    getInteger( value, defaultValue ) {
        try {
            if( ( typeof value == "number" ) && ( Math.floor( value ) == value ) ) {
                return value;
            }
            else if( ( typeof value == "string" ) && ( value.length > 0 ) && !isNaN( value ) && ( Math.floor( parseFloat( value ) ) == value ) ) {
                return parseInt( value );
            }
        }
        catch( e ) {
            //
        }
        return defaultValue;
    }

    getFloat( value, defaultValue ) {
        try {
            if( typeof value == "number" ) {
                return value;
            }
            else if( ( typeof value == "string" ) && ( value.length > 0 ) && !isNaN( value ) ) {
                return parseFloat( value );
            }
        }
        catch( e ) {
            //
        }
        return defaultValue;
    }

    getBoolean( value, defaultValue ) {
        try {
            if( typeof value == "boolean" ) {
                return value;
            }
            else if( typeof value == "string" ) {
                if( ( value === "1" ) || ( value === "yes" ) ) {
                    return true;
                }
                else if( ( value === "0" ) || ( value === "no" ) ) {
                    return false;
                }
                else if( value.length === 0 ) {
                    return false;
                }
            }
            else if( typeof value == "number" ) {
                if( value === 1 ) {
                    return true;
                }
                else if( value === 0 ) {
                    return false;
                }
            }
        }
        catch( e ) {
            //
        }
        return defaultValue;
    }

    getArray( value, defaultValue ) {
        try {
            if( ( typeof value == "object" ) && ( value != null ) && ( value.length > 0 ) ) {
                return value;
            }
        }
        catch( e ) {
            //
        }
        return defaultValue;
    }

    getArrayFromObject( value, defaultValue ) {
        try {
            if( ( typeof value == "object" ) && ( value != null ) && ( Object.keys( value ).length > 0 ) ) {
                let objectArray = [];

                Object.keys( value ).map( ( valueKey) => objectArray.push( value[valueKey] ) );

                return objectArray;
            }
        }
        catch( e ) {
            //
        }
        return defaultValue;
    }

    getObject( value, defaultValue ) {
        try {
            if( ( typeof value == "object" ) && ( value != null ) && ( Object.keys( value ).length > 0 ) ) {
                return value;
            }
        }
        catch( e ) {
            //
        }
        return defaultValue;
    }

    getCopy( object ) {
        return JSON.parse( JSON.stringify( object ) );
    }

    getElement( elementId ) {
        try {
            let element = document.getElementById( elementId );
            if( ( typeof element != "undefined" ) && ( element != null ) ) {
                return element;
            }
        }
        catch( e ) {
            //
        }
        return null;
    }

    isMatchObjects( object1, object2 ) {
        object1 = this.getObject( object1, null );
        object2 = this.getObject( object2, null );

        if( ( object1 != null ) && ( object2 != null ) ) {
            try {
                if( JSON.stringify( object1 ) === JSON.stringify( object2 ) ) {
                    return true;
                }
            }
            catch( e ) {
                //
            }
        }
        else if( ( object1 == null ) && ( object2 == null ) ) {
            return true;
        }

        return false;
    }

    isMatchArrays( array1, array2 ) {
        array1 = this.getArray( array1, null );
        array2 = this.getArray( array2, null );

        if( ( array1 != null ) && ( array2 != null ) ) {
            try {
                if( JSON.stringify( array1 ) === JSON.stringify( array2 ) ) {
                    return true;
                }
            }
            catch( e ) {
                //
            }
        }
        else if( ( array1 == null ) && ( array2 == null ) ) {
            return true;
        }

        return false;
    }

    getDistance( geoposition, station ) {
        let coef = 57.295779;

        return Math.floor(
            Math.acos( Math.sin( station.latitude / coef )
                * Math.sin( geoposition.latitude / coef )
                + Math.cos( station.latitude / coef )
                * Math.cos( geoposition.latitude / coef )
                * Math.cos( ( station.longitude - geoposition.longitude ) / coef )
            )
            * 6371000
        );
    }

    numberFormat( number, precision ) {
        let numberString = parseFloat( number ).toFixed( precision ).replaceAll( '.', ',' );
        if( precision > 0 ) {
            let pad = "," + "".padStart( precision, "0" );
            numberString = numberString.replaceAll( pad, '' );
        }
        return numberString;
    }

    getPlural( number, word1, word2, word3 ) {
        try {
            let integerNumber = Math.floor( number );

            if( integerNumber !== 0 ) {
                let lastDigits = integerNumber;
                let highPart = Math.floor( lastDigits / 100 );
                if( highPart > 0 ) {
                    lastDigits -= highPart;
                }

                if( ( lastDigits >= 11 ) && ( lastDigits <= 19 ) ) {
                    return word3;
                }

                highPart = Math.floor( lastDigits / 10 );
                if( highPart > 0 ) {
                    lastDigits -= highPart;
                }

                if( lastDigits === 1 ) {
                    return word1;
                }
                else if( lastDigits <= 4 ) {
                    return word2;
                }
            }
        }
        catch( e ) {
            //
        }

        return word3;
    }

}